var installmentRatesWatches = {
    3: 0.0075,
    4: 0.0100,
    5: 0.0125,
    6: 0.0150,
    7: 0.0175,
    8: 0.0200,
    9: 0.0225,
    10: 0.0250,
    11: 0.0275,
    12: 0.0300,
    15: 0.0375,
    18: 0.0450,
    20: 0.0500,
    24: 0.0600,
    30: 0.0750,
    36: 0.0900,
    42: 0.1050,
    48: 0.1200,
    54: 0.1350,
    60: 0.1500,
    66: 0.1650,
    72: 0.1800,
    78: 0.1950,
    84: 0.2100,
    90: 0.2250,
    96: 0.2400,
    102: 0.2550,
    108: 0.2700,
    114: 0.2850,
    120: 0.3000
};

var installmentRatesJewelry = {
    3: 0.0105,
    4: 0.0140,
    5: 0.0175,
    6: 0.0210,
    7: 0.0245,
    8: 0.0280,
    9: 0.0315,
    10: 0.0350,
    11: 0.0385,
    12: 0.0420,
    15: 0.0525,
    18: 0.0630,
    20: 0.0700,
    24: 0.0840,
    30: 0.1050,
    36: 0.1260,
    42: 0.1470,
    48: 0.1680,
    54: 0.1890,
    60: 0.2100,
    66: 0.2310,
    72: 0.2520,
    78: 0.2730,
    84: 0.2940,
    90: 0.3150,
    96: 0.3360,
    102: 0.3570,
    108: 0.3780,
    114: 0.3990,
    120: 0.4200
};

document.addEventListener("DOMContentLoaded", function () {
    const installmentsSelect = document.getElementById('installments');
    for (const value in installmentRatesWatches) {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = `${value}`;
        installmentsSelect.appendChild(option);
    }
});

// ボーナス併用を選択した際に、ボーナス関連の入力フィールドを動的に追加 test
function updateBonusFields() {
    const paymentMethod = document.querySelector('input[name="paymentMethod"]:checked').value;
    const bonusFields = document.getElementById('bonusFields');
    const bonusPaymentsFields = document.getElementById('bonusPaymentsFields');
    const resultBonusFields = document.getElementById('resultBonusFields'); // Add this line

    if (paymentMethod === 'bonus') {
        bonusFields.style.display = 'block';
        bonusPaymentsFields.style.display = 'block';
        resultBonusFields.style.display = 'table-row'; // Show the bonus row
    } else {
        bonusFields.style.display = 'none';
        bonusPaymentsFields.style.display = 'none';
        resultBonusFields.style.display = 'none'; // Hide the bonus row
    }
}

// ページ読み込み時とラジオボタン変更時にボーナス関連のフィールドを更新
document.addEventListener('DOMContentLoaded', updateBonusFields);
document.querySelectorAll('input[name="paymentMethod"]').forEach(function (radio) {
    radio.addEventListener('change', updateBonusFields);
});

function calculateLoan() {
    const cashPrice = parseFloat(document.getElementById('cashPrice').value);
    const downPayment = parseFloat(document.getElementById('downPayment').value) || 0;
    const installments = parseInt(document.getElementById('installments').value);
    const paymentMethod = document.querySelector('input[name="paymentMethod"]:checked').value;
    const bonusAmount = parseFloat(document.getElementById('bonusAmount').value) || 0;
    const bonusPayments = parseInt(document.getElementById('bonusPayments').value) || 0;
    const itemType = document.getElementById('itemType').value;

    let installmentRates;

    if (itemType === 'watch') {
        installmentRates = installmentRatesWatches;
    } else {
        installmentRates = installmentRatesJewelry;
    }

    const installmentFee = (cashPrice - downPayment) * installmentRates[installments];
    let totalPayment = cashPrice + installmentFee - downPayment;
    let subsequentPayment = 0;
    let totalBounusPayment = bonusAmount * bonusPayments;

    if (isNaN(cashPrice) || isNaN(downPayment) || isNaN(installments) || isNaN(bonusAmount) || isNaN(bonusPayments)) {
        alert("金額を入れて下さい。");
        return;
    }

    if (paymentMethod === 'equal') {
        subsequentPayment = Math.floor(totalPayment / installments);
    } else if (paymentMethod === 'bonus') {
        subsequentPayment = Math.floor((totalPayment - totalBounusPayment) / installments);
    }

    subsequentPayment = Math.floor(subsequentPayment / 100) * 100;

    const initialPayment = totalPayment - totalBounusPayment - (subsequentPayment * (installments - 1));
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() + 1);
    const startMonthText = `${startDate.getFullYear()}年${startDate.getMonth() + 1}月`;
    document.getElementById('startMonth').textContent = startMonthText;

    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + installments - 1);
    const endMonthText = `${endDate.getFullYear()}年${endDate.getMonth() + 1}月`;

    document.getElementById('installmentFee').textContent = escapeHtml(Math.ceil(installmentFee).toLocaleString());
    document.getElementById('finalDownPayment').textContent = escapeHtml(Math.ceil(downPayment).toLocaleString());
    document.getElementById('totalPayment').textContent = escapeHtml(Math.ceil(totalPayment).toLocaleString());
    document.getElementById('totalBounusPayment').textContent = escapeHtml(Math.ceil(totalBounusPayment).toLocaleString());
    document.getElementById('initialPayment').textContent = escapeHtml(Math.ceil(initialPayment).toLocaleString());
    document.getElementById('subsequentPayment').textContent = escapeHtml(subsequentPayment.toLocaleString());
    document.getElementById('endMonth').textContent = endMonthText;

    const resultSection = document.getElementById('resultSection');
    resultSection.style.display = 'block';
    window.scrollTo(0, resultSection.offsetTop);
}

// HTMLエスケープ関数
function escapeHtml(str) {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
